module.exports = __webpack_public_path__ + "static/media/graphql.7c64d4f7.png";